// apps/web/src/lib/useVersionGate.ts
// Native update gate: with bundled assets the app can't be updated by a web
// deploy anymore, so a broken binary needs a way to be retired in the field.
// Compares the native build number against /api/version. FAILS OPEN — any
// error, timeout, or non-native context never blocks the app.
import { useEffect, useState } from "react";
import { isNativeApp } from "./native";
import { API_BASE } from "./apiBase";

export function useVersionGate(): boolean {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    if (!isNativeApp()) return;
    let cancelled = false;
    (async () => {
      try {
        const { App } = await import("@capacitor/app");
        const info = await App.getInfo();
        const build = Number(info.build);
        if (!Number.isFinite(build) || build <= 0) return;
        const ctl = new AbortController();
        const timer = setTimeout(() => ctl.abort(), 5000);
        const res = await fetch(`${API_BASE}/api/version`, { signal: ctl.signal });
        clearTimeout(timer);
        if (!res.ok) return;
        const { min_supported_build } = await res.json() as { min_supported_build: number };
        if (!cancelled && build < min_supported_build) setBlocked(true);
      } catch { /* fail open */ }
    })();
    return () => { cancelled = true; };
  }, []);

  return blocked;
}
